/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_Art_Row_4Inputs */

const en_services_svc_full_art_row_4 = /** @type {(inputs: Services_Svc_Full_Art_Row_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nightly backup`)
};

const lv_services_svc_full_art_row_4 = /** @type {(inputs: Services_Svc_Full_Art_Row_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakts rezerves kopija`)
};

/**
* | output |
* | --- |
* | "Nightly backup" |
*
* @param {Services_Svc_Full_Art_Row_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_art_row_4 = /** @type {((inputs?: Services_Svc_Full_Art_Row_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_Art_Row_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_art_row_4(inputs)
	return en_services_svc_full_art_row_4(inputs)
});